import { Container as BaseContainer, LayoutProps } from "@cgc/ui/layout";
import { clsx } from "@cgc/ui/utils/clsx";
import React from "react";

export const Container: React.FC<LayoutProps> = (props) => (
  <BaseContainer
    {...props}
    className={clsx(props.className, "!max-w-[1280px]")}
  />
);
